.ux-tab {
  display: none;
  width: 100%;

  &__margin-collapse-guard {
    display: flex;
    height: fit-content;
  }

  &.is-active {
    display: block;
  }

  &--with-slider {
    display: block;
    height: 0;
    overflow: hidden;
    pointer-events: none;
    position: absolute;
    visibility: hidden !important;

    &.is-active,
    &.ux-tab--anchor-navigation {
      height: auto;
      overflow: auto;
      pointer-events: auto;
      position: inherit;
      visibility: inherit !important;
    }
  }

  &--anchor-navigation {
    display: block;
  }
}
